export enum CampaignViewEnum {
    Preview = 'preview',
    Settings = 'settings',
    SettingsEdit = 'settingsEdit',
    Credits = 'credits',
    Winners = 'winners',
    WinnersEdit = 'winnersEdit',
}